import { render } from "./ListWarehouses.vue?vue&type=template&id=8e2d5fbc&scoped=true"
const script = {}

import "./ListWarehouses.vue?vue&type=style&index=0&id=8e2d5fbc&scoped=true&lang=css"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e2d5fbc"]])

export default __exports__